import { useAction } from '@reatom/npm-react'
import { useMemo } from 'react'

import { reatomTelegramAuthentication } from '@root/features/auth/telegram'

/**
 * Signing in, from anywhere in a browser.
 *
 * One way through: the bot. It knows who they are, which is the whole of
 * signing in here — no password, no name to choose, no invite code to find.
 *
 * It exists as a hook because three screens need the same button and each
 * had its own answer before: the door built it inline, and the topbar and
 * the tables offered to download the desktop app instead, which is not a way
 * to sign in at all.
 */
export const useWebSignIn = () => {
  const telegram = useMemo(
    // eslint-disable-next-line @reatom/unit-naming-rule
    () => reatomTelegramAuthentication(),
    [],
  )
  return useAction(telegram.execute)
}
